import { HTTPInstanceWithPrefix } from '@/lib/http/http-instance-with-prefix'
import {
  AllergensResponseModel,
  DietsResponseModel,
  IngredientPayloadModel,
  IngredientsResponseModel,
  UnitsResponseModel
} from './IngredientsAPI.model'

class IngredientsAPI {
  static getAllergens = (): Promise<AllergensResponseModel> =>
    HTTPInstanceWithPrefix.get('/all-allergens').then(response => response.data)

  static getUnits = (): Promise<UnitsResponseModel> =>
    HTTPInstanceWithPrefix.get('/all-units').then(response => response.data)

  static getDiets = (): Promise<DietsResponseModel> =>
    HTTPInstanceWithPrefix.get('/all-diets').then(response => response.data)

  static getIngredients = (): Promise<IngredientsResponseModel> =>
    HTTPInstanceWithPrefix.get('/ingredients').then(response => response.data)

  static postIngredient = (
    payload: IngredientPayloadModel
  ): Promise<IngredientPayloadModel> =>
    HTTPInstanceWithPrefix.post('/ingredients', payload).then(
      response => response.data
    )

  static deleteIngredients = (ingredientIds: string[]): Promise<void> =>
    HTTPInstanceWithPrefix.delete('/ingredients', {
      data: { ids: ingredientIds }
    }).then(response => response.data)

  static putIngredient = (
    ingredientId: string,
    payload: IngredientPayloadModel
  ): Promise<IngredientPayloadModel> =>
    HTTPInstanceWithPrefix.put(`/ingredients/${ingredientId}`, payload).then(
      response => response.data
    )
}

export default IngredientsAPI
